let nextId = 1000000;

export default function getId(){
    return nextId++;
}